<template>
    <router-view :class="[(dialogData || hbData) && 'filter-show']"/>
    <base-component :class="[(dialogData || hbData) && 'filter-show']"/>
    <dialog-component/>
    <hong-bao v-if="hbData" :data="hbData"/>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import BaseComponent from '@/components/Base.vue'
import DialogComponent from '@/components/Dialog.vue'
import HongBao from '@/components/HongBao.vue'

import Moment from 'moment'
import COVERAPP from '@/utils/COVERAPP'

@Options({
    created () {
        this.getActDetail()
    },
    watch: {
        $route (to, from) {
            if (to.fullPath != from.fullPath) {
                this.SET_HBDATA(null)
                this.SET_DIALOGDATA(null)
                this.$common.pageLoading()
            }
        }
    },
    computed: {
        ...mapState(['aid', 'userInfo', 'shareData', 'dialogData', 'hbData'])
    },
    components: {
        BaseComponent,
        DialogComponent,
        HongBao
    },
    mounted () {
        this.$common.rootRem(.5625)
        window.addEventListener('pageshow', (e) => {
            if (e.persisted) {
                window.location.reload()
            }
        })
        if (COVERAPP.Attribute.isApp()) {
            this.$common.getUser((res: any) => {
                this.SET_USERINFO(res)
            })
        }
        const yearData = sessionStorage.getItem('YEARDATA')
        if (yearData) {
            this.SET_YEARDATA(JSON.parse(yearData))
        }
    },
    methods: {
        ...mapMutations(['SET_USERINFO', 'SET_SHAREDATA', 'SET_DIALOGDATA' , 'SET_YEARDATA', 'SET_ACTIVITYDATA', 'SET_HBDATA']),
        getActDetail (): void {
            this.$request('/activity/config', {
                aid: this.aid
            }).then((data: any) => {
                // 设置分享信息
                data.share && this.setShareData(data.share)
                this.loadImgs(data)
            })
        },
        activityStatus (data: any) {
            if (new Date(data.serverTime).getTime() < new Date(data.startTime).getTime()) {
                this.SET_DIALOGDATA({
                    text: `亲，红包尚未开启，<br/>请在${Moment(data.startTime).format('YYYY.MM.DD')}-${Moment(data.endTime).format('YYYY.MM.DD')}时间段内<br/>来参与！`
                })
            } else if (new Date(data.serverTime).getTime() > new Date(data.endTime).getTime()) {
                this.SET_DIALOGDATA({
                    text: '亲，红包发完啦，欢迎下次再来'
                })
            } else if (data.isAppShow && !COVERAPP.Attribute.isApp()) {
                this.appShow(data.openApp)
            }
        },
        setShareData (data: any) {
            const _this = this
            this.SET_SHAREDATA({
                title: data.title,
                desc: data.desc,
                imgUrl: data.imgUrl || 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
                link: window.location.href.split('#')[0]
            })
            this.$common.onshare(this.shareData, this.aid)
        },
        appShow (data: any) {
            this.SET_DIALOGDATA({
                text: '参加该活动需在封面新闻APP中进行',
                btns: [
                    {
                        text: '确定',
                        className : 'download-btn',
                        data
                    }
                ]
            })
        },
        loadImgs (data: any) {
            const imgs = ['bus.png', 'data_bg.jpg', 'data_build.png', 'foot_01_bg.jpg', 'foot_02_bg.jpg', 'foot_03_bg.jpg', 'foot_04_bg.jpg', 'foot_05_bg.jpg', 'foot_title.png', 'hb_bg.png', 'home_bg.jpg', 'home_list_btn.png', 'list_hb_icon.png', 'logo.png', 'open_hb.png', 'title.png', 'view_bg.jpg']
            let index = 0
            let len = imgs.length
            for(let img of imgs) {
                this.$common.onloadImg(require(`@/assets/img/${img}`)).then(() => {
                    index++
                    if (index == len) {
                        this.$common.pageLoaded()
                        this.SET_ACTIVITYDATA(data)
                        // 判断活动状态
                        this.activityStatus(data)
                    }
                })
            }
        }
    }
})
export default class App extends Vue {}
</script>
